import type z from 'zod';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { ApiResponse } from '@/types/api-types';
import type { paths } from '~/generated/smart-form/api-schema';
import { smartFormApi } from '@/services';
import {
  queryTemplateParamBaseSchema,
  queryTemplateResponseSchema,
} from './types/query-template-schema';

const API_PATH = '/v1/template/queryDraftTemplate' as const;

export { API_PATH as QUERY_DRAFT_TEMPLATE_KEY };

type APIResponse = ApiResponse<paths, typeof API_PATH>;

const queryDraftTemplateParamSchema = queryTemplateParamBaseSchema;

export type APIParams = z.infer<typeof queryDraftTemplateParamSchema>;

const queryFn = async (params: APIParams, signal: AbortSignal) => {
  const { data: response } = await smartFormApi.get<APIResponse>(API_PATH, {
    params,
    signal,
  });

  return queryTemplateResponseSchema.parse(response.data);
};

export const getSuspenseQueryDraftTemplateOptions = (params: APIParams) =>
  queryOptions({
    queryKey: [API_PATH, params],
    queryFn: ({ signal }) => queryFn(params, signal),
  });

export const useSuspenseQueryDraftTemplate = (params: APIParams) =>
  useSuspenseQuery(getSuspenseQueryDraftTemplateOptions(params));
